module.exports = __webpack_public_path__ + "static/media/shower-rain.5a50429d.png";